export default __webpack_public_path__ + "static/09_3.6mm_IRcut-589666a06126007655cbf45f7882feef.webp";